import React, { useState } from "react";
import "./FinalCTABanner.css";
import InquiryFormModal from "../InquiryFormModal/InquiryFormModal";
import { useLocation } from "react-router-dom";

const FinalCTABanner = () => {
  const [modalshow, setmodalshow] = useState(false);
  const location = useLocation();

  // Hide banner on /universities routes
  if (location.pathname.startsWith("/universities")) {
    return null;
  }

  return (
    <>
      <section className="final-cta-banner">
        <div className="container-fluid p-0">
          <div className="banner_div">
            <img
              src="/assets/images/home/banner/final_cta.webp"
              className="img"
              alt="Career growth banner"
              // onClick={() => setmodalshow(true)}
            />

            <button
              className="cta-btn apply_btn"
              onClick={() => setmodalshow(true)}
            >
              Talk To a Counselor
            </button>
          </div>
        </div>
      </section>

      <InquiryFormModal
        show={modalshow}
        onHide={() => setmodalshow(false)}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </>
  );
};

export default FinalCTABanner;